import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const chatAvailabilityQuery = gql`
  query GetChatAvailability {
    chatAvailability {
      ... on ChatAvailabilitySuccess {
        __typename
        message
      }
      ... on ChatAvailabilityBusy {
        __typename
        message
      }
      ... on ChatAvailabilityOffline {
        __typename
        message
      }
      ... on ChatAvailabilityDisabled {
        message
        __typename
      }
      ... on ChatAvailabilityError {
        __typename
        ...error
      }
    }
  }
  ${error}
`;

export default chatAvailabilityQuery;
